import { Card } from "antd";
import { RoutesIcon } from "components/svgs/menu/RoutesIcon";
import React from "react";
import { Link } from "react-router-dom";

const HomeCard = ({
  icon = <RoutesIcon width={40} height={40} fill="#1278F1" />,
  title,
  description,
  buttonText,
  buttonLink = "#",
  onClick,
  disabled = false
}) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Card className={disabled ? "disabled-card" : ""}>
      <div className="text-center">
        <div className="card-icon">{icon}</div>
        <p className="card-title">{title}</p>
        <p className="card-description">{description}</p>
        {onClick ? (
          <button className="card-cta" onClick={handleClick} disabled={disabled}>
            {buttonText}
          </button>
        ) : (
          <Link className="card-cta" to={buttonLink}>
            {buttonText}
          </Link>
        )}
      </div>
    </Card>
  );
};

export default HomeCard;
